<template>
  <div style="width: 100%; position: relative">
    <div id="your-dom-id" class="nc-container"></div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.initNoCaptcha();
  },
  methods: {
    reset() {
      window.nc.reset();
    },
    initNoCaptcha() {
      /* eslint-disable */
      let thant = this;
      // 弹出式，除region和prefix以外的参数
      window.initAliyunCaptcha({
        // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        SceneId: "4l5gtb05",
        // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
        mode: "embed",
        // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        element: "#your-dom-id",
        success: function (captchaVerifyParam) {
          console.log(captchaVerifyParam, "1");
          if (captchaVerifyParam) {
            thant.$emit("successAWSC", {
              disabledBtn: false,
              code: captchaVerifyParam,
            });
          }
          // let nc = new noCaptcha(NC_Opt);
          // window.nc = nc;
          // nc.upLang("cn", {
          //   _startTEXT: "请按住滑块，拖动到最右边",
          //   _yesTEXT: "验证通过",
          //   _error300:
          //     '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
          //   _errorNetwork:
          //     '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>',
          // });
        },
        // 验证码验证不通过回调函数
        fail: function (result) {
          console.log(result, "2");
          // 入参为不通过信息
          // 正常验证有效期内不需要做任何操作，验证码自动刷新，重新进行验证
          console.error(result);
        },
        // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
        getInstance: function (instance) {
          console.log(instance, "3");
          // captcha = instance;
        },
        // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。
        slideStyle: {
          width: 360,
          height: 40,
        },
        // ...其他参数，参考initAliyunCaptcha参数说明
      });

      // var nc_token = [
      //   "FFFF0N0000000000A38F",
      //   new Date().getTime(),
      //   Math.random(),
      // ].join(":");
      // var NC_Opt = {
      //   element: "#your-dom-id",
      //   appkey: "FFFF0N0000000000A38F",
      //   mode: "popup",
      //   SceneId: "nc_other",
      //   token: nc_token,
      //   customWidth: 300,
      //   trans: { key1: "code0" },
      //   elementID: ["usernameID"],
      //   is_Opt: 0,
      //   language: "cn",
      //   isEnabled: true,
      //   timeout: 3000,
      //   times: 5,
      //   apimap: {},
      //   success: function (captchaVerifyParam) {
      //     if (captchaVerifyParam) {
      //       thant.$emit("successAWSC", {
      //         disabledBtn: false,
      //         code: captchaVerifyParam,
      //       });
      //     }
      //   },
      // };
      // let nc = new noCaptcha(NC_Opt);
      // window.nc = nc;
      // nc.upLang("cn", {
      //   _startTEXT: "请按住滑块，拖动到最右边",
      //   _yesTEXT: "验证通过",
      //   _error300:
      //     '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
      //   _errorNetwork:
      //     '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>',
      // });
      /* eslint-disable */
    },
  },
};
</script>
